import { Component, viewChild, inject } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { ButtonComponent } from '../../../../../shared/components/button/button.component';
import { RequestBuilderService } from '../../../../../shared/services/request-builder.service';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';

@Component({
  selector: 'app-delay-notification-dialog',
  standalone: true,
  imports: [FormsModule, ButtonComponent, TextareaModule, InputTextModule],
  templateUrl: './delay-notification-dialog.component.html',
  styleUrl: './delay-notification-dialog.component.scss',
})
export class DelayNotificationDialogComponent {
  ref = inject(DynamicDialogRef);
  config = inject(DynamicDialogConfig);
  private readonly requestBuilder = inject(RequestBuilderService);

  readonly delayNotificationForm = viewChild.required<NgForm>('delayNotificationForm');
  loading = false;

  confirmAction() {
    const delayNotificationForm = this.delayNotificationForm();
    if (delayNotificationForm.invalid) return;

    this.loading = true;

    const body = {
      Title: delayNotificationForm.value.delayAlert,
      Body: delayNotificationForm.value.description,
    };
    this.requestBuilder.post(`notifications/${this.config.data.uuid}/send-delay-notification`, body).subscribe({
      next: () => {
        this.loading = false;
        this.ref.close({ confirmed: true });
      },
      error: error => {
        this.loading = false;
      },
    });
  }
}
